<app-form-manager
  formPlugin="core-configuration-form"
  [params]="params"
  (canceled)="cancel($event)"
  (saveSucceed)="saveSucceed($event)"
  #form>
</app-form-manager>
